
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M12.1786 7.25V11.7143L15.75 15.2857"></path><path d="M2.35718 11.7143C2.35721 13.9743 3.13669 16.1652 4.56414 17.9174C5.99159 19.6696 7.97967 20.8759 10.193 21.3328C12.4064 21.7897 14.7097 21.4692 16.7143 20.4255C18.7189 19.3818 20.3022 17.6787 21.1971 15.6034C22.0921 13.5281 22.244 11.2076 21.6271 9.03342C21.0102 6.85919 19.6624 4.96424 17.8109 3.66817C15.9594 2.3721 13.7176 1.75423 11.4635 1.91878C9.45871 2.06513 7.55334 2.82248 6 4.07964"></path><path d="M7.46801 6.26688L2.72111 6.53059L4.30341 2.04741L7.46801 6.26688Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiHistoricversion",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
